import { startsWithSegment } from 'router5-helpers';
export var getRoute = function (segment, routes) {
    // eslint-disable-next-line
    for (var _i = 0, routes_1 = routes; _i < routes_1.length; _i++) {
        var route = routes_1[_i];
        if (route.name === segment) {
            return route;
        }
        if (startsWithSegment(segment, route.name) && route.children) {
            var splitSegment = segment.split('.');
            splitSegment.shift();
            if (splitSegment.length > 0) {
                return getRoute(splitSegment.join('.'), route.children);
            }
        }
    }
    throw new Error('route not found');
};
